<div class="marketing-dashboard-container">
	<h2 class="page-title">Marketing Dashboard</h2>

	<p-tabView>
		<p-tabPanel header="Guest Marketing">
			<app-guest-tab [snapshot]="guestSnapshot"></app-guest-tab>
		</p-tabPanel>
		<p-tabPanel header="Homeowner Marketing">
			<div class="coming-soon-panel">
				<p>Coming Soon</p>
			</div>
		</p-tabPanel>
	</p-tabView>
</div>
